import { useRequest } from 'features/request/useRequest';
import { useProjectData } from 'hooks/useProjectData';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { uerRemoveActsKC3Gql } from '../actKC3ListQueries';

interface IUseActKC3ListDeleteItems {
    contractId: number;
    checkedIds: Array<number>;
    refreshTable: () => void;
    resetChecked: () => void;
}

export const useActKC3ListDeleteItems = (props: IUseActKC3ListDeleteItems) => {
    const dispatch = useDispatch();
    const { id } = useParams();

    const { contractId, checkedIds, refreshTable, resetChecked } = props;

    const { refreshProject } = useProjectData(id, false);

    const onSuccess = useCallback(() => {
        refreshProject();
        refreshTable();
        resetChecked();
    }, [refreshProject, refreshTable, resetChecked]);

    const [deleteData, deleteStatus, deleteErr, deleteRequest, deleteSetData] = useRequest({
        requestId: 'deleteActKc3',
        withEffect: false,
        query: uerRemoveActsKC3Gql,
        dependenciesUpdater: onSuccess,
    });

    const handleDelete = useCallback(() => {
        dispatch(
            deleteRequest({
                contractId,
                actKC3Ids: checkedIds,
            }),
        );
    }, [checkedIds, contractId, deleteRequest, dispatch]);

    return {
        deleteData: deleteData?.uerRemoveActsKC3,
        deleteErr,
        deleteStatus,
        handleDelete,
        deleteSetData,
    };
};
